import { IconBase } from './IconBase'

type IconGoogleProps = React.ComponentProps<'svg'>

export const IconGoogle = (props: IconGoogleProps) => {
  return (
    <IconBase width="1em" viewBox="0 0 24 24" {...props}>
      <path
        d="M22.305 10.041H21.5V10h-9v4h5.651A5.998 5.998 0 0 1 6.5 12a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52L19.31 4.69A9.954 9.954 0 0 0 12.5 2c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-.67-.069-1.325-.195-1.959Z"
        fill="#FFC107"
      />
      <path
        d="m3.653 7.346 3.285 2.409A5.997 5.997 0 0 1 12.5 6c1.53 0 2.92.577 3.98 1.52L19.31 4.69A9.954 9.954 0 0 0 12.499 2a9.994 9.994 0 0 0-8.846 5.346Z"
        fill="#FF3D00"
      />
      <path
        d="M12.5 22c2.583 0 4.93-.988 6.705-2.596l-3.095-2.619A5.955 5.955 0 0 1 12.5 18a5.997 5.997 0 0 1-5.641-3.973L3.598 16.54C5.253 19.778 8.614 22 12.5 22Z"
        fill="#4CAF50"
      />
      <path
        d="M22.305 10.041H21.5V10h-9v4h5.651a6.02 6.02 0 0 1-2.043 2.785h.002l3.095 2.619C18.985 19.602 22.5 17 22.5 12c0-.67-.069-1.325-.195-1.959Z"
        fill="#1976D2"
      />
    </IconBase>
  )
}
